// Subscription offers are not playback options in the Caroline interface.
const isSubscriptionStream = (stream) => {
    const text = [stream?.name, stream?.title, stream?.description]
        .filter((value) => typeof value === 'string').join(' ').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').toLowerCase();
    return /\b(?:subscription|subscricao)\b/.test(text);
};

module.exports = isSubscriptionStream;
